// extracted by mini-css-extract-plugin
module.exports = {"Showcase":"Showcase_Showcase__-yROG"};